import { render, staticRenderFns } from "./PublicCatalogProduct.vue?vue&type=template&id=62c08838&"
import script from "./PublicCatalogProduct.vue?vue&type=script&lang=js&"
export * from "./PublicCatalogProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports